export var ImportErrors;
(function (ImportErrors) {
    ImportErrors["noCameraPermissions"] = "no_camera_permissions";
    ImportErrors["noGalleryPermissions"] = "no_gallery_permissions";
})(ImportErrors || (ImportErrors = {}));
